var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bg-white",
      style: _vm.getStyle,
      attrs: { id: "jobsCreatedByUserCard" },
    },
    [
      _c(
        "vx-card",
        [
          _c("h2", { staticClass: "mb-2" }, [
            _vm._v("Mes derniers postes/stages créés"),
          ]),
          _vm._v(" "),
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                {
                  attrs: {
                    "vs-type": "flex",
                    "vs-justify": "center",
                    "vs-align": "center",
                    "vs-w": "12",
                  },
                },
                [
                  _c(
                    "DialogPrompt",
                    {
                      attrs: {
                        active: _vm.showPopup,
                        title: "Consulter un poste/stage",
                        "cancel-text": "Fermer",
                        "accept-text": "Enregistrer",
                        "button-accept": "true",
                      },
                      on: {
                        "update:active": function ($event) {
                          _vm.showPopup = $event
                        },
                      },
                    },
                    [
                      _c("JobForm", {
                        attrs: { type: "show" },
                        model: {
                          value: _vm.resource,
                          callback: function ($$v) {
                            _vm.resource = $$v
                          },
                          expression: "resource",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "vs-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        sst: true,
                        "no-data-text": "Aucune donnée à afficher",
                        data: _vm.jobs,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ data }) {
                            return _vm._l(_vm.jobs, function (item, i) {
                              return _c(
                                "vs-tr",
                                { key: i, attrs: { data: item } },
                                [
                                  _c(
                                    "vs-td",
                                    [
                                      _c("feather-icon", {
                                        attrs: { icon: "ClipboardIcon" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "vs-td",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: {
                                            content: item.description,
                                            placement: "top-start",
                                            classes: ["occ-description"],
                                          },
                                          expression:
                                            "{\n                                    content: item.description,\n                                    placement: 'top-start',\n                                    classes: ['occ-description'],\n                                }",
                                        },
                                      ],
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.showResource(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.get(item, ":title"))
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("vs-td", [
                                    _c(
                                      "p",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.showResource(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.get(item, ":service.title")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("vs-td", [
                                    _c(
                                      "p",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.showResource(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.get(
                                              item,
                                              ":service.establishment.name"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("vs-td", [
                                    _c(
                                      "p",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.showResource(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.get(item, ":created_at"))
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            })
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "template",
                        { slot: "thead" },
                        [
                          _c("vs-th"),
                          _vm._v(" "),
                          _c("vs-th", [_vm._v("Poste/Stage")]),
                          _vm._v(" "),
                          _c("vs-th", [_vm._v("Service")]),
                          _vm._v(" "),
                          _c("vs-th", [_vm._v("Etablissement")]),
                          _vm._v(" "),
                          _c("vs-th", [_vm._v("Créé le")]),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "vs-row",
            [
              _c("vs-col", { staticClass: "text-right mt-2" }, [
                _c("a", { attrs: { href: "/rh/referentiel/postes" } }, [
                  _vm._v("Voir plus..."),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }